import React from "react";

function Banner() {
  return (
    <div className="contenedor-banner">
      <div className="banner mt-5">
        <h1>EL PALOMO MENSAJERO</h1>
        <h2>¡Nosotros lo decimos por ti!</h2>
        <hr className="hr-banner" />
      </div>
    </div>
  );
}

export default Banner;
